import {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";

export const useWebRTCSupport = () => {
  const [isWebRTCSupported, setIsWebRTCSupported] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const {t} = useTranslation();

  useEffect(() => {
    const checkWebRTCSupport = () => {
      setIsLoading(true);
      const errors = [];

      if (
        window.location.protocol !== "https:" &&
        window.location.hostname !== "localhost"
      ) {
        errors.push(t("popup.webrtc.https"));
      }

      if (
        !window.RTCPeerConnection &&
        !window.webkitRTCPeerConnection &&
        !window.mozRTCPeerConnection
      ) {
        errors.push(t("popup.webrtc.webrtc_api"));
      }

      const hasGetUserMedia = !!(
        navigator.mediaDevices?.getUserMedia ||
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia
      );

      const hasRTCPeerConnection = !!(
        window.RTCPeerConnection ||
        window.webkitRTCPeerConnection ||
        window.mozRTCPeerConnection
      );

      const hasRTCDataChannel = !!(
        window.RTCDataChannel ||
        window.webkitRTCDataChannel ||
        window.mozRTCDataChannel
      );

      const hasICE = !!(
        window.RTCIceCandidate ||
        window.webkitRTCIceCandidate ||
        window.mozRTCIceCandidate
      );

      if (!hasGetUserMedia) errors.push(t("popup.webrtc.media"));
      if (!hasRTCPeerConnection) errors.push(t("popup.webrtc.peer"));
      if (!hasRTCDataChannel) errors.push(t("popup.webrtc.channel"));
      if (!hasICE) errors.push(t("popup.webrtc.ice"));

      if (errors.length === 0) {
        setIsWebRTCSupported(true);
        setErrorMessage(null);
      } else {
        setIsWebRTCSupported(false);
        setErrorMessage(`${errors.join(", ")}.`);
      }
      setIsLoading(false);
    };

    checkWebRTCSupport();
  }, []);

  return {isWebRTCSupported, errorMessage, isLoading};
};
